import React from 'react';

interface AdminHeaderProps {
  adminData?: any;
  onLogout: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ adminData, onLogout }) => {
  return (
    <header className="bg-orange-500 shadow-sm border-b border-orange-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-4">
            <button
              onClick={() => window.location.href = '/admin'}
              className="flex items-center space-x-4 hover:opacity-80 transition-opacity cursor-pointer"
            >
              <div className="w-8 h-8 rounded-lg flex items-center justify-center">
                <img 
                  src="/images/Asset2.png" 
                  alt="Temple" 
                  className="w-full h-full object-contain rounded-lg"
                />
              </div>
              <h1 className="text-2xl font-bold text-white">Temple Admin Panel</h1>
            </button>
          </div>
          <div className="flex items-center space-x-4">
            <span className="text-white">Welcome, {adminData?.full_name || 'Temple Administrator'}</span>
            <button
              onClick={onLogout}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
